import React, { useEffect, useRef, useState } from "react";
import style from "../style.module.scss"
import "../index.css"
import { ReactComponent as EditIcon } from '../../../../../assets/svg/ai-agents/editIcon.svg'
import { ReactComponent as DeleteIconColor } from '../../../../../assets/svg/ai-agents/deleteIcon.svg'
import { ReactComponent as DeleteIcon } from '../../../../../assets/svg/ai-agents/delete-icon-without-color.svg'
import { ReactComponent as AddItem } from '../../../../../assets/svg/ai-agents/addItem.svg'
import { ReactComponent as GenerateIcon } from '../../../../../assets/svg/ai-agents/generateIcon.svg'
import { ReactComponent as CloseBtn } from '../../../../../assets/svg/ai-agents/closebtn.svg'
import { ReactComponent as GeminiLogo } from '../../../../../assets/svg/ai-agents/geminiIcon.svg'
import { ReactComponent as GptLogo } from '../../../../../assets/svg/ai-agents/gptIcon.svg'
import { ReactComponent as ClaudeLogo } from '../../../../../assets/svg/ai-agents/claude-ai-icon.svg'
import { ReactComponent as UniphoreLogo } from '../../../../../assets/svg/sidemenu/uniphore_logo.svg'
import { ReactComponent as EnterIcon } from '../../../../../assets/svg/ai-agents/enter_ico.svg'
import { Input, InputNumber, Select, Tag, Tooltip } from "antd";
import { VariablesLists } from "../variablesList";
import { ToolsDrawer } from "./toolsDrawer";
import { Agent, AgentDetails, ToolsList, VariablesType } from "../types";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Http } from "../../../../../helpers/axois";
import { useSelector } from "react-redux";
import { PromptGallery } from "./promptGallery";
import { useToast } from "../../../../../helpers/commonFunction";
import { AnimatePresence, motion } from "framer-motion";
import { modalVariants, pageVariants, pageVariants1 } from "../framerAnimations";
import { EditorPanel } from "../markDownEditor";
import axios from "axios";
import { AppState } from "../../../../../stateManager/store";
import * as  _ from "lodash"
const { Option } = Select;

const CreateAgents = () => {
    const history = useHistory()
    const pathname = useLocation().pathname
    const parts = pathname.split("/");
    const lastPart = parts[parts.length - 1]
    const editorRef = useRef<HTMLDivElement>(null);
    const params: { appId?: string, agentId: string } = useParams()
    const appId = params.appId
    const selectedOrg = useSelector((state: any) => state.org.selectedOrg)
    const paramsAgentId = params.agentId || "";
    const currentBranch: any = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    })
    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    const { orgName } = useSelector((state: any) => state.org.selectedOrg)
    const appVersion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId ?? ""]);
    const currentVersion = appVersion && appVersion.currentVersion;
    const canEditAgents = currentVersion && (orgPermissions.includes('aiAgent.Edit') || appPermissions.includes('aiAgent.Edit') || lastPart === "create")
    const { ErrorToast, SuccessToast } = useToast()
    const branchId = currentBranch && currentBranch.branchId
    const [selectedRagAgents, setSelectedRagAgents] = useState<string[]>([])
    const [ragAgents, setRagAgents] = useState<Agent[]>([])
    const [editToolsData, setEditToolData] = useState<ToolsList>({
        id: 0,
        name: "",
        description: "",
        function: "",
        params: []
    })
    const [agentId, setAgentId] = useState<string>(paramsAgentId ?? "")
    const [errors, setErrors] = useState({ name: '', prompt: "", model: '', provider: '', topP: "", temperature: "", maxOutputTokens: "" })
    const [editorHeight, setEditorHeight] = useState<number>(450);
    const [showOutputFields, setShowOutputFields] = useState<boolean>(false);
    const [variables, setVariables] = useState<string[]>([])
    const [showAddFields, setShowAddFields] = useState<boolean>(variables?.length === 0 ? false : true)
    const [showVariablesFields, setShowVariablesFields] = useState<boolean>(variables?.length === 0 ? false : true);
    const [showRagAgentFields, setShowRagAgentFields] = useState<boolean>(selectedRagAgents?.length === 0 ? false : true);
    const [showToolsDrawer, setShowToolsDrawer] = useState<boolean>(false);
    // const [isPlaceholderVisible, setIsPlaceholderVisible] = useState<boolean>(false);
    const [outputVariables, setOutputVariables] = useState<VariablesType[]>([])
    const [toolsVariables, setToolsVariables] = useState<VariablesType[]>([])
    const [toolsList, setToolsList] = useState<ToolsList[]>([])
    const [inputValue, setInputValue] = useState<string>('');
    const [structuredOutput, setStructuredOutput] = useState<boolean>(false)
    const [prompt, setprompt] = useState<string>("")
    const [agentDetails, setAgentDetails] = useState<AgentDetails>({
        name: "",
        prompt: "",
        // inputVars: [],
        llm: {
            provider: "",
            model: "",
            config: {
                temperature: 1,
                topP: 1,
                maxOutputTokens: 4000
            },
        },
        // ragAgents: [],
        tools: []
    })
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    // const [editName, setEditName] = useState<boolean>(false)
    const [agentName, setAgentName] = useState<string>("")
    const [updateDisabled, setUpdateDisabled] = useState<boolean>(false)
    const modelsProvider = [
        { label: "OpenAI", value: "openai" }, 
        { label: "Gemini", value: "gemini" },
        { label: "Anthropic", value: "anthropic"},
        { label: "Uniphore", value: "uniphore"}
    ]
    const openAiModels = [{ label: "gpt-4-turbo", value: "gpt-4-turbo" }, { label: "gpt-4o", value: "gpt-4o" }, { label: "gpt-4o-mini", value: "gpt-4o-mini" }]
    const geminiModels = [{ label: "gemini-1.5-pro", value: "gemini-1.5-pro" }, { label: "gemini-1.5-flash", value: "gemini-1.5-flash" }]
    const claudeModels = [
        { label: "claude-3-5-sonnet", value: "claude-3-5-sonnet" },
        { label: "claude-3-5-opus", value: "claude-3-opus" },
        { label: "claude-3-5-haiku", value: "claude-3-haiku" },
    ]
    const uniphoreModels = [
        { label: "Facts-8b-SLM", value: "facts-8b-slm"},
        { label: "Summary-8b-SLM", value: "summary-8b-slm"},
        { label: "Chat-70b-LLM", value: "chat-70b-llm"}
    ]
    const outputStructure = [{ label: "JSON", value: "json" }, { label: "Plain Text", value: "plainText" }]
    const modalRef = useRef(null);

    const startResize = (e: React.MouseEvent) => {
        e.preventDefault();
        const startY = e.clientY;
        const startHeight = editorRef.current?.offsetHeight || 400;

        const resize = (moveEvent: MouseEvent) => {
            const newHeight = startHeight + (moveEvent.clientY - startY);
            setEditorHeight(newHeight > 100 ? newHeight : 100); // Minimum height of 100px
        };

        const stopResize = () => {
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize);
        };

        window.addEventListener('mousemove', resize);
        window.addEventListener('mouseup', stopResize);
    };

    const getAgent = () => {
        Http.get(`/apps/${appId}/ai-agents/${agentId}?branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
            if (res?.aiAgent) {
                const { createdAt, updatedAt, createdBy, updatedBy, aiAgentKey, inputVars, id, ...rest } = res?.aiAgent || {}
                // delete rest.llm.config.topK;
                setAgentDetails(rest || {})
                setprompt(rest.prompt)
                setOutputVariables(rest.outputParams?.map((res: VariablesType, index: number) => { return { ...res, type: res?.enum && res?.enum?.length > 0 ? "enum" : res.type, id: index } }) || [])
                // setVariables(rest.inputVars)
                setShowAddFields(false)
                setSelectedRagAgents(rest?.ragAgents || [])
                setStructuredOutput(rest.outputParams?.length > 0 ? true : false)
                if (res.aiAgent.tools) {
                    setToolsList(res.aiAgent.tools?.map((res: ToolsList, index: number) => {
                        return {
                            ...res,
                            id: index
                        }
                    }))
                }
            }
        }, (err) => {
            ErrorToast("Failed to fetch Agent details")
        })

    }

    const getRagAgentsList: () => Promise<Agent[] | [] | undefined> = async () => {
        if (!window.env.GENAI_URL) {
            return
        }
        const url = `${window.env.GENAI_URL}/api/v1/bot/bots?orgId=${selectedOrg.id}`
        try {
            const { data } = await axios.get(url, {
                headers: {
                    'X-STUDIO-TOKEN': localStorage.getItem("studioToken"),
                }
            })
            const agents: Agent[] = data.bots.map((bot: any) => ({ id: bot._id, name: bot.name, addAgent: false, removeAgent: false }))
            return agents
        } catch (e){
            return []
        }
    }

    // async function getAgentsForApp(orgId: string, appId: string, agents: Agent[]) {
    //     const agentIds = agents.map(el => el.id)
    //     const data: any = await Http.get(`org/${orgId}/apps/${appId}`).toPromise()
    //     console.log({data})
    //     setRagAgents((data[0].ai_agents ?? []).filter((el: string) => agentIds.includes(el)))
    // }
    
    useEffect(() => {
        if (agentId) {
            getAgent()
        }
        getRagAgentsList().then((agents) => {
            setRagAgents(agents ? agents: [])
        })    
    }, [])

    const validate = () => {
        let hasError = false;
        const newErrors = { name: '',prompt: "", model: '', provider: '', topP: "", temperature: "", maxOutputTokens : ""};

        if (!agentDetails.name.trim()) {
            newErrors.name = 'Please enter agent name';
            hasError = true;
        }

        if (!prompt.trim()) {
            newErrors.prompt = 'Please enter instruction';
            hasError = true;
        }

        if (!agentDetails.llm.provider) {
            newErrors.provider = 'Please select provider';
            hasError = true;
        }

        if (!agentDetails.llm.model) {
            newErrors.model = 'Please select model';
            hasError = true;
        }

        if (!agentDetails.llm.config.temperature || agentDetails.llm.config.temperature < 0 || agentDetails.llm.config.temperature > 2) {
            newErrors.temperature = 'Enter temperature value 0 - 2';
            hasError = true;
        }

        if (!agentDetails.llm.config.maxOutputTokens || agentDetails.llm.config.maxOutputTokens < 1 || agentDetails.llm.config.maxOutputTokens > 8192) {
            newErrors.maxOutputTokens = 'Output token limit 1 - 8192';
            hasError = true;
        }

        if (!agentDetails.llm.config.topP || agentDetails.llm.config.topP < 0 || agentDetails.llm.config.topP > 1 ) {
            newErrors.topP = 'Enter Top-P limit 0 - 1';
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError;
    };

    const createAgent = _.debounce(() => {
        if (!validate()) return;

        setAgentDetails((prevState: AgentDetails) => {
            return { ...prevState, prompt, inputVars: variables, outputParams: outputVariables, tools: toolsList };
        });

        const filterToolsList = toolsList.map((el) => {
            const { id, params, ...rest } = el;
            const filteredParams = params.map((param) => {
                const { id, enum: enumValues, ...restParams } = param;
                return {
                    ...restParams,
                    ...(param.type === "enum" && { type: "string", enum: enumValues })
                }
            });

            return {
                ...rest,
                params: filteredParams
            };
        });

        const filterOutputParams = outputVariables.map((el) => {
            const { id, enum: enumValues, ...rest } = el;
            return {
                ...rest,
                ...(el.type === "enum" && { type: "string", enum: enumValues })
            };
        });
        const payload = { 
            ...agentDetails, 
            prompt,
            // inputVars: variables || [],
            ragAgents: selectedRagAgents || [], 
            tools: filterToolsList || [], 
            outputParams: filterOutputParams || [] 
        }
        delete payload.inputVars

        if (agentId) {
            Http.put(`/apps/${appId}/ai-agents/${agentId}?branchId=${branchId}&versionId=${versionId}`, payload).subscribe((res: any) => {
                if (res) {
                    SuccessToast("Agent updated successfully")
                } else {
                    ErrorToast("Failed to update Agent")
                }
            }, (err) => {
                ErrorToast("Failed to update Agent", err)
            })

            return
        }

        Http.post(`/apps/${appId}/ai-agents?branchId=${branchId}&versionId=${versionId}`, payload).subscribe((res: any) => {
            if (res) {
                setAgentId(res.id)
                SuccessToast("Agent created successfully")
            }else{
                ErrorToast("Failed to create Agent")
            }
        }, (err) => {
            if (err && err.error === "ai agent already exists") {
                ErrorToast("Agent already exist")
            } else {
                ErrorToast("Failed to create Agent", err)
            }
        })
    }, 300)

    const handleLLMChanges = (field: string, e: string) => {
        setErrors((prevState) => { return { ...prevState, [field]: "" } })
        setAgentDetails((prevState: AgentDetails) => {
            return {
                ...prevState, llm: {
                    ...prevState.llm,
                    [field]: e
                }
            };
        });
    };


    const handleLLMConfigChanges = (field: string, e: number | undefined) => {
        setErrors((prevState) => { return { ...prevState, [field]: "" } })
        setAgentDetails((prevState: AgentDetails) => {
            return {
                ...prevState, llm: {
                    ...prevState.llm,
                    config: {
                        ...prevState.llm.config,
                        [field]: e
                    }
                }
            };
        });
    };

    const handleKeyCapture = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && inputValue.trim() !== '') {
            setVariables([...variables, inputValue.trim()]);
            setInputValue('');
        }
    };

    const handleRemoveTag = (removedTag: string) => {
        setVariables(variables.filter(variable => variable !== removedTag));
        setShowVariablesFields(variables.filter(variable => variable !== removedTag)?.length === 0 ? false : true)
    };

    const handleRemoveAgent= (agent: string) => {
        setSelectedRagAgents(selectedRagAgents.filter(ragAgent => ragAgent !== agent));
        setShowRagAgentFields(selectedRagAgents.filter(ragAgent => ragAgent !== agent)?.length === 0 ? false : true)
    };

    const handleRagAgentSelect = (value: any) => {
        setSelectedRagAgents([...value])
    }
    
    useEffect(() => {
        if(!showToolsDrawer){
            setEditToolData({
                id: 0,
                name: "",
                description: "",
                function: "",
                params: []
            })
        }
    }, [showToolsDrawer])
    
    const modelsList = agentDetails.llm.provider === "openai" ? openAiModels : agentDetails.llm.provider === "gemini" ? geminiModels : agentDetails.llm.provider === "anthropic" ? claudeModels : agentDetails.llm.provider === "uniphore" ? uniphoreModels : [];
    return (
        <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={pageVariants1}
        >
            <div className={style.createAgentHeader}>
                <div className={style.createAgentTitleContainer}>
                    <Input
                        disabled={!canEditAgents}
                        className={style.createAgentName}
                        style={{
                            border: "1px solid #D9D9D9",
                            width: 360
                        }}
                        placeholder="Enter Agent Name"
                        value={agentName ? agentName : agentDetails.name ? agentDetails.name : ""}
                        onChange={(e) => {
                            setErrors((prevState) => { return { ...prevState, name: "" } });
                            setAgentName(e.target.value); setAgentDetails({...agentDetails, name: e.target.value})
                         }}
                    />
                    {errors.name && <span style={{paddingLeft: 5}} className={style.errorMessage}>{errors.name}</span>}
                </div>

                <div style={{display: "flex"}}>
                    <button className={style.cancelButton} onClick={() => {
                        history.goBack()
                    }}>Cancel</button>
                    {canEditAgents && <button 
                        className={style.saveAgentButton} 
                        onClick={() => {
                            createAgent();
                        }}
                        >Save</button>}
                </div>
            </div>

            <div style={{ borderBottom: "1px solid #95ABD34D", margin: "0px 10px 0px 10px"}}></div>

            <div className={style.createAgentContentContainer}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className={style.editorContainer}
                        ref={editorRef}
                        style={{ height: `${editorHeight}px` }}
                    >
                        <div className={style.editorHeader}>
                            <p className={style.editorHeaderTitle}>Instructions</p>
                            {canEditAgents && <div style={{ display: "flex", cursor: "pointer", alignItems: "center", padding: "12px 15px 12px 0px" }} onClick={() => { setIsModalOpen(true) }}>
                                <GenerateIcon style={{ marginRight: 6 }} />
                                <p style={{padding: 0}} className={style.editorHeaderTitle}>Prompt Gallery</p>
                            </div>}
                        </div>

                        <EditorPanel type="markdown" setErrors={setErrors} setPrompt={setprompt} setSourceData={setAgentDetails} source={prompt} agentDetails={agentDetails} height={`${editorHeight - 130}px`} canEditAgents={canEditAgents}/>

                        <div className={style.resizeHandle} onMouseDown={startResize}></div>
                    </div>
                    {errors.prompt && <span style={{ paddingLeft: 5 }} className={style.errorMessage}>{errors.prompt}</span>}
                    {/* <div className={style.outputFormatContainer} style={{
                        borderBottom: (showVariablesFields || (agentDetails?.inputVars && agentDetails.inputVars.length > 0)) ? "10px solid #3461A21A" : 0 
                    }}>
                        <div className={style.outputHeader}>
                            <div className={style.outputHeaderText}>Variables</div>
                            {((!agentDetails?.inputVars || agentDetails.inputVars.length <= 0) && variables?.length <= 0 && !showVariablesFields) && <div className={style.addFields}>
                                {canEditAgents && <div className={style.addFieldsContainer}
                                    onClick={() => {
                                        setShowVariablesFields(true)
                                    }}
                                > <AddItem style={{ marginRight: 5 }} /> Add Variables</div>}
                            </div>}
                        </div>

                        {(showVariablesFields || (agentDetails?.inputVars && agentDetails.inputVars.length > 0)) && (
                            <motion.div
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                variants={pageVariants1}
                                style={{ background: "#3461A21A" }}>
                                <div className={style.inputTagsContainer}>
                                    <Input
                                        className="input-variables"
                                        suffix={<EnterIcon />}
                                        style={{ width: 250, height: 36 }}
                                        value={inputValue}
                                        disabled={!canEditAgents}
                                        onChange={(e) => setInputValue(e.target.value)}
                                        onKeyPressCapture={handleKeyCapture}
                                        placeholder="Enter a variable and press Enter"
                                    />
                                    {variables?.map((variable, index) => {
                                        return (
                                            <Tag
                                                id=""
                                                className={style.inputVariableTags}
                                                key={variable}
                                                closable={canEditAgents}
                                                onClose={() => handleRemoveTag(variable)}
                                            >
                                                {variable}
                                            </Tag>)
                                    })}
                                </div>
                            </motion.div>
                        )}
                        
                    </div> */}
                    <div className={style.toolsContainer}>
                        <div className={style.toolsHeader}>
                            <div className={style.toolsHeaderTitle}>Tools</div>


                            {canEditAgents && <div className={style.toolsAddFieldButton}
                                onClick={() => {
                                    setShowToolsDrawer(true)
                                }}
                            > <AddItem style={{ marginRight: 5 }} /> Add Tools</div>}
                        </div>

                        {toolsList?.length > 0 && <div style={{ background: "#3461A21A" }}>
                            {toolsList.map((tool: ToolsList) => {
                                return (
                                    <motion.div
                                    key={tool.id}
                                        initial="hidden"
                                        animate="visible"
                                        exit="exit"
                                        variants={pageVariants1}
                                        className={style.toolsListContainer}>
                                        <div className={style.toolsNameContainer}>
                                            <p className={style.toolsName}>{tool.name}</p>
                                            <div style={{display: "flex", marginRight: 20}}>
                                               {canEditAgents && <EditIcon style={{ marginRight: 10, cursor: "pointer" }} onClick={() => {
                                                    const findToolVariables = toolsList.filter((e) => { return (tool.id === e.id) })

                                                    setEditToolData(findToolVariables[0])
                                                    setToolsVariables(findToolVariables[0]?.params?.map((val: VariablesType, index: number) => { return { ...val, id: index } }) || [])
                                                    setShowToolsDrawer(true)
                                                }
                                                } />}
                                                {/* {canEditAgents && <DeleteIcon style={{ cursor: "pointer" }} onClick={() => {
                                                    setToolsList(toolsList.filter((editTool) => { return editTool.id !== tool.id }))
                                                }} />}
                                                {canEditAgents && <DeleteIconColor style={{ cursor: "pointer" }} onClick={() => {
                                                    setToolsList(toolsList.filter((editTool) => { return editTool.id !== tool.id }))
                                                }} />} */}

                                                {canEditAgents && (
                                                    <div className={style.deleteIconWrapper} onClick={() => {
                                                        setToolsList(toolsList.filter((editTool) => editTool.id !== tool.id));
                                                    }}>
                                                        <DeleteIcon className={style.defaultDeleteIcon} />
                                                        <DeleteIconColor className={style.hoverDeleteIcon} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className={style.toolsDesc}>{tool.description}</div>
                                    </motion.div>
                                )
                            })}
                        </div>}
                    </div>
                </div>

                <div style={{ width: "100%" }} className={style.modalContainer}>
                    <div className={style.modelContent}>
                        <div className={style.modelProvider}>
                            <span className={style.fieldHeader}>Provider</span>
                            <Select
                                disabled={!canEditAgents}
                                mode="default"
                                value={agentDetails.llm.provider || undefined}
                                className="providerSelect"
                                style={{height: 36}}
                                dropdownClassName="agent-provider-drop-down"
                                placeholder="Select Provider"
                                onChange={(e) => {
                                    handleLLMChanges("provider", e)
                                    handleLLMChanges("model", "")
                                }}
                            >
                                {modelsProvider.map((model) => (
                                    <Option key={model.value} value={model.value}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {model.value === "openai" ?
                                                <GptLogo style={{ marginRight: 5 }} /> 
                                            : model.value === "gemini" ?
                                                 <GeminiLogo style={{ marginRight: 5 }} /> 
                                            : model.value === "anthropic" ?
                                                <ClaudeLogo style={{marginRight: 5}}/>
                                            :  
                                                <UniphoreLogo style={{ marginRight: 5, height: 18, width: 18 }} />
                                            } 
                                            {model.label}
                                        </div>
                                    </Option>
                                )
                                )}
                            </Select>
                            {errors.provider && <span className={style.errorMessage}>{errors.provider}</span>}
                        </div>

                        <div className={style.modelList}>
                            <span className={style.fieldHeader}>Models</span>
                            <Select
                                disabled={!canEditAgents}
                                value={agentDetails.llm.model || undefined}
                                className="providerSelect"
                                style={{ height: 36 }}
                                placeholder="Select model"
                                dropdownClassName="agent-drop-down"
                                onChange={(e) => {
                                    handleLLMChanges("model", e)
                                }}
                            >
                                {modelsList.map((model) => {
                                    return (
                                        <Option key={model.value} value={model.value}>{model.label}</Option>
                                    )
                                })}
                            </Select>
                            {errors.model && <span className={style.errorMessage}>{errors.model}</span>}
                        </div>
                    </div>


                    <div className={style.modelContent} style={{ paddingTop: 24 }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            <Tooltip placement="top" title="Enter temperature value 0 - 2">
                                <span className={style.fieldHeader} style={{ textDecoration: "underline dashed", textUnderlineOffset: 5 }}>Temperature</span>
                            </Tooltip>
                            <InputNumber
                                disabled={!canEditAgents}
                                min={0}
                                max={1}
                                type="number"
                                className="llm-config-list"
                                value={agentDetails.llm.config.temperature ?? 1}
                                placeholder="Temperature"
                                onChange={(value) => {
                                    handleLLMConfigChanges("temperature", value)
                                }}
                            />
                            {errors.temperature && <span className={style.errorMessage}>{errors.temperature}</span>}
                        </div>

                        <div className={style.inputFields} style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            <Tooltip placement="top" title="Output token limit 1 - 8192">
                                <span className={style.fieldHeader} style={{ textDecoration: "underline dashed", textUnderlineOffset: 5 }}>Output Token Limit</span>
                            </Tooltip>
                            <InputNumber
                                disabled={!canEditAgents}
                                className="llm-config-list"
                                type="number"
                                value={agentDetails.llm.config.maxOutputTokens ?? 4000}
                                placeholder="Token limit"
                                onChange={(value) => {
                                    handleLLMConfigChanges("maxOutputTokens", value)
                                }}
                            />
                            {errors.maxOutputTokens && <span className={style.errorMessage}>{errors.maxOutputTokens}</span>}
                        </div>

                        {/* 
                        <div className={style.inputFields}>
                            <span className={style.fieldHeader}>Top-K *</span>
                            <Input
                                type="number"
                                value={agentDetails.llm.config.topK ?? 1}
                                placeholder="Top K"
                                onChange={(e) => {
                                    handleLLMConfigChanges("topK", e.target.value)
                                }}
                            />
                        </div> */}
                        <div className={style.inputFields} style={{ display: "flex", flexDirection: "column", width:"100%" }}>
                            <Tooltip placement="top" title="Enter Top-P limit 0 - 1">
                                <span className={style.fieldHeader} style={{ textDecoration: "underline dashed", textUnderlineOffset: 5 }}>Top-P</span>
                            </Tooltip>
                            <InputNumber
                                disabled={!canEditAgents}
                                min={0}
                                max={2}
                                className="llm-config-list"
                                type="number"
                                value={agentDetails.llm.config.topP ?? 1}
                                placeholder="Top P"
                                onChange={(e) => {
                                    handleLLMConfigChanges("topP", e)
                                }}
                            />
                            {errors.topP && <span className={style.errorMessage}>{errors.topP}</span>}
                        </div>
                    </div>

                    <div className={style.outputFormatContainer} style={{
                        margin: "24px 0px 15px 0px",
                        borderBottom: (showRagAgentFields || (agentDetails?.ragAgents && agentDetails.ragAgents.length > 0)) ? "10px solid #3461A21A" : 0
                    }}>
                        <div className={style.outputHeader}>
                            <div className={style.outputHeaderText}>Knowledge Base</div>
                            {((!agentDetails?.ragAgents || agentDetails.ragAgents.length <= 0) && selectedRagAgents?.length <= 0 && !showRagAgentFields) && canEditAgents &&<div className={style.addFields}>
                                <div className={style.addFieldsContainer}
                                    onClick={() => {
                                        setShowRagAgentFields(true)
                                    }}
                                > <AddItem style={{ marginRight: 5 }} /> Add Source</div>
                            </div>}
                        </div>

                        {(showRagAgentFields || (agentDetails?.ragAgents && agentDetails.ragAgents.length > 0)) && (
                            <motion.div
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                variants={pageVariants1}
                                style={{ background: "#3461A21A" }}>
                                <div className={style.inputTagsContainer}>
                                    <Select
                                        disabled={!canEditAgents}
                                        mode="multiple"
                                        suffixIcon={<EnterIcon />}
                                        style={{ width: 250 }}
                                        placeholder="Select Sources"
                                        className="rag-agent-select"
                                        dropdownClassName="rag-agent-dropdown"
                                        onChange={handleRagAgentSelect}
                                        value={selectedRagAgents?.length > 0 ? selectedRagAgents : undefined}
                                        showSearch
                                        maxTagCount={0}
                                        maxTagPlaceholder={() => null}
                                        filterOption={(input, option: any) => {
                                            return (option && option.props)
                                                ?
                                                option?.props?.label?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                : false
                                        }}
                                    >
                                        {ragAgents
                                            .filter((agent: Agent) => !selectedRagAgents?.includes(agent.id))
                                            .map((agent: Agent, index: number) => {
                                                return (
                                                    <Option key={agent.id} label={agent.name} value={agent.id}>
                                                        {agent.name}
                                                    </Option>
                                                );
                                            })}
                                    </Select>
                                    {selectedRagAgents?.map((id, index) => {
                                        const agentName = ragAgents.find((agent) => agent.id === id)
                                        return (
                                            <Tag
                                                className={style.inputVariableTags}
                                                key={id}
                                                closable
                                                onClose={() => handleRemoveAgent(agentName?.id || "")}
                                            >
                                                {agentName?.name}
                                            </Tag>)
                                    })}
                                </div>
                            </motion.div>
                        )}

                    </div>

                    <div className={style.outputFormatContainer} style={{
                        // marginTop: 20,
                        borderBottom: (showOutputFields || outputVariables?.length > 0) && structuredOutput ? "10px solid #3461A21A" : 0
                    }}>
                        <div className={style.outputHeader}>
                            <div className={style.outputHeaderText}>Output Format</div>
                            <div className={style.addFields}>
                                {structuredOutput && canEditAgents && <div className={style.addFieldsContainer}
                                    onClick={() => {
                                        setShowOutputFields(true)
                                        setShowAddFields(true)
                                    }}
                                > <AddItem style={{ marginRight: 5 }} /> Add Field</div>}

                                {structuredOutput && <div className={style.divider} style={{ rotate: "90deg", border: "1px solid #95ABD34D", padding: "0px 10px 0px 10px" }}></div>}

                                {/* <CustomSelect outputStructure={outputStructure} setStructuredOutput={setStructuredOutput} structuredOutput={structuredOutput}/> */}
                                <Select
                                    disabled={!canEditAgents}
                                    value={structuredOutput ? "json" : "plainText"}
                                    // className={style.addFieldStructure}
                                    className="outputStructureSelect"
                                    placeholder="Select Type"
                                    dropdownClassName="outputStructureSelectOptions"
                                    onChange={(e: any) => {
                                        if (e === "json") {
                                            setStructuredOutput(true)
                                        } else {
                                            setStructuredOutput(false)
                                        }
                                    }}
                                >
                                    {outputStructure.map((model) => {
                                        return (
                                            <Option key={model.value} value={model.value}>
                                                {model.label}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </div>

                        {(showOutputFields || outputVariables?.length > 0) && structuredOutput &&
                            <VariablesLists
                                canEditAgents={canEditAgents}
                                showAddFields={showAddFields}
                                hideAddFields={setShowAddFields}
                                variables={outputVariables}
                                setVariables={setOutputVariables}
                                hideFields={setShowOutputFields}
                            />}


                        {showToolsDrawer &&
                            <motion.div
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                variants={pageVariants}
                            >
                                <ToolsDrawer
                                    canEditAgents={canEditAgents}
                                    editToolData={editToolsData}
                                    toolsVariables={toolsVariables}
                                    toolsList={toolsList}
                                    setToolsList={setToolsList}
                                    setToolsVariables={setToolsVariables}
                                    visible={showToolsDrawer}
                                    setVisible={setShowToolsDrawer}
                                />
                            </motion.div>}
                    </div>
                </div>
            </div>

            <AnimatePresence>
                {isModalOpen && (
                    <div
                        className={style.modalOverlay}
                    >
                        <motion.div
                            ref={modalRef}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={modalVariants}
                            className={style.modalContent}>
                            <div className={style.modalHeader}>
                                <p className={style.modalHeaderTitle}>Prompt Gallery</p>
                                <CloseBtn style={{ cursor: "pointer" }} onClick={() => setIsModalOpen(false)} />
                            </div>
                            <PromptGallery
                                appId={appId || ""}
                                setInstructions={setprompt}
                                setVisible={setIsModalOpen}
                                setAgentDetails={setAgentDetails}
                                agentDetails={agentDetails}
                            />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

        </motion.div>
    )
}

export default CreateAgents